import type { SpotlightBounds } from './utils'

export const getGuideTourForceClickAffordanceLayout = (
  bounds: Pick<SpotlightBounds, 'width' | 'height'>,
  overflowPx: number
): {
  anchorTop: number
  anchorLeft: number
  anchorWidth: number
  anchorHeight: number
  centerX: number
  centerY: number
} => ({
  anchorTop: -overflowPx,
  anchorLeft: -overflowPx,
  anchorWidth: bounds.width + overflowPx * 2,
  anchorHeight: bounds.height + overflowPx * 2,
  centerX: overflowPx + bounds.width / 2,
  centerY: overflowPx + bounds.height / 2,
})

export const expandGuideTourForceClickTargetBounds = (
  bounds: SpotlightBounds,
  overflowPx: number
): SpotlightBounds => {
  const layout = getGuideTourForceClickAffordanceLayout(bounds, overflowPx)

  return {
    top: bounds.top + layout.anchorTop,
    left: bounds.left + layout.anchorLeft,
    width: layout.anchorWidth,
    height: layout.anchorHeight,
  }
}
